import {BranchesStates} from "../../States";

/**
 * update branch handler
 * @param payload
 * @returns {*}
 */
export function updateBranches(payload) {
    if (!payload) return null;
    localStorage.setItem('branches', JSON.stringify(payload));

    return {
        type: BranchesStates.SUCCESS,
        payload,
    };
}
